$(document).ready(function(){

  if($('.img-txt-sldier-main').length > 0){
    $('.img-txt-sldier-main').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true,
      arrows:false
    });
  }


  if($('.testimonials-main-cls').length > 0){
    $('.testimonials-main-cls').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay:true,
      arrows:false,
      responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true
        }
      }
    ]
    });
  }

  $('.tabs-cstm-label label').click(function(){
    $('.tabs-cstm-content-main').removeClass('active');
    $('.tabs-cstm-label label').removeClass('active');
    var id = $(this).attr('id');
    $(this).addClass('active');
    $('.tabs-cstm-content-main').each(function(){
        var idd = $(this).attr('id');
        if(id == idd){
            $(this).addClass('active');
        }
    })
  })
  
})